import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton, Divider } from "@mui/material";
import { styles } from "./styles";

const TrophyCardLoader = () => (
  <Box sx={styles.card}>
    <Skeleton variant="text" width="80%" height={18} />
    <Skeleton variant="text" width="40%" height={18} />
    <Box sx={styles.bottomRow}>
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="rounded" width={38} height={60} />
    </Box>
  </Box>
);

export const TrophiesLoader = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "trophies" });

  return (
    <Box sx={styles.container}>
      <Box sx={styles.contentWrapper}>
        <Typography sx={styles.title}>{t("trophies")}</Typography>
        <Box sx={styles.trophyGrid}>
          {[1, 2, 3, 4, 5].map((index) => (
            <TrophyCardLoader key={index} />
          ))}
        </Box>
      </Box>
      <Divider orientation="horizontal" />
      <Box sx={{ padding: "16px 0", width: "100%" }}>
        <Skeleton variant="text" width="20%" height={24} sx={{ margin: "0 auto" }} />
      </Box>
    </Box>
  );
};
